import { Button, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  button: {
    borderRadius: `100px`,
    width: '320px',
  },
  footerContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  leftSide: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'start',
    margin: '20px',
  },
  leftSideElement: {
    marginBottom: '40px',
    width: '80%',
  },
  rightSide: {
    width: '100%',
    display: 'flex',
  },
}));

const PricingTableFooter = () => {
  const classes = useStyles();

  const handleOnClick = () => {
    window.open('https://meetings.hubspot.com/tara-faquir/pricing-info-session', '_blank');
  };

  return (
    <div className={classes.footerContainer}>
      <div className={classes.leftSide}>
        <Typography className={classes.leftSideElement} variant="h4">
          Not sure what plan to pick?
        </Typography>
        <Typography className={classes.leftSideElement} variant="body2">
          Connect with a Trustate expert on an initial call to discuss how Trustate administration
          can help.
        </Typography>
        <Button
          className={(classes.leftSideElement, classes.button)}
          variant="contained"
          size="medium"
          color="primary"
          onClick={handleOnClick}
        >
          Schedule a Demo
        </Button>
      </div>
      <div className={classes.rightSide}>
        <img src="/pricing-table-footer.png" alt="Two individuals discussing pricing options." />
      </div>
    </div>
  );
};

export default PricingTableFooter;
